import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'containers/App/actions';
import { ChecklistComponent } from 'components/NCCheckList/Checklist';

const GeneralTaskList = ({ data }) => {
  const [activeTaskIndex, setActiveTask] = useState(-1);
  const { tasks, assignmentOptions } = data || {};
  const dispatch = useDispatch();
  const { createNotificationTask } = bindActionCreators(actions, dispatch);

  const createTask = () => {
    const variables = {
      module: 'loginTasks',
      input: {},
      referenceId: tasks.length > 0 ? tasks[0].id : null,
    };

    if (variables) {
      createNotificationTask({ variables });
      setActiveTask(0);
    }
  };

  return (
    <div name="checklist">
      <div name="headers">
        <div name="controls">
          <button
            className="APIconButton"
            name="add"
            onClick={createTask}
          >
            +
          </button>
        </div>
        <h2
          name="name"
          className="heading-section"
        >
          General Tasks
        </h2>
        {tasks?.length < 1 && (
          <div name="empty">
            You can assign general tasks to yourself or others here without adding them to a project.
          </div>
        )}
      </div>
      <ChecklistComponent
        tasks={tasks}
        assignmentOptions={assignmentOptions}
        module="loginTasks"
        active={activeTaskIndex}
        setActive={setActiveTask}
      />
    </div>
  );
};

export default GeneralTaskList;
